import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router';
import { AuthenticationContext } from '../msal/AuthenticationContext';
import { AuthorizationContext, authorizationStates } from '../context/AuthorizationContext';
import { TenantContext } from '../context/TenantContext';
import { Spinner } from './Spinner';
import { LoginScreen } from './LoginScreen';
import { urls } from '../logic/urls';

export const ProtectedRoute = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
    const authorizationContext = useContext(AuthorizationContext);
    const tenantContext = useContext(TenantContext);

    // Check if user is authenticated
    if (!authenticationContext.isAuthenticated()) {
        return <LoginScreen/>
    }

    // If tenants have been loaded but the list is empty, redirect to create a tenant
    if (tenantContext.hasLoadedTenants && tenantContext.availableTenants.length === 0) {
        return <Redirect to={urls.createTenant} />
    }

    // Check if tenant is selected
    if (!tenantContext.tenantId || tenantContext.tenantId === "") {
        return <Spinner/>
    }

    // Check authorization state
    if (authorizationContext.authorizationState === authorizationStates.UNKNOWN ||
        authorizationContext.authorizationState === authorizationStates.CHECKING) {
        return <Spinner/>
    }

    if (authorizationContext.isAuthorized()) {
        return <Route {...props} component={props.component} />
    }

    // User is authenticated but not authorized
    return <Redirect to='/unauthorized' />
}